<template>
  <div class="full_page">
    <h1>Samples Only</h1>
    <div class="row">
      <div class="col-12">
        <table class="table table-striped table-bordered table-hover table-condensed">
          <thead>
          <tr>
            <th>#</th>
            <th>Customer Id</th>
            <th>Company Name</th>
            <th>Days Ago</th>
            <th width = "180">First Sample Date</th>
            <th>Total Samples</th>
            <th>Gummies</th>
            <th>Sour Gummies</th>
            <th>My Sleep</th>
            <th>Pre-Roll</th>
            <th>Eighth Wonder</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="customer in samples_only_list" v-bind:key="customer.customer_id" :style="{color: line_color(customer.list_color), background: background_color(customer.has_to_pay)}">
            <td>{{customer.position}}</td>
            <td style="cursor: pointer; text-decoration: underline" v-on:click="show_customer_detail_page(customer.customer_id)">{{customer.customer_id}}</td>
            <td>{{customer.customer_display_name}}</td>
            <td>{{customer.days_ago}}</td>
            <td style="white-space:nowrap;">{{customer.first_order_date_formatted}}</td>
            <td>{{customer.sample_counts.TOTAL}}</td>
            <td>{{customer.sample_counts.GUMMIES}}</td>
            <td>{{customer.sample_counts.SOUR}}</td>
            <td>{{customer.sample_counts.SLEEP}}</td>
            <td>{{customer.sample_counts.PREROLL}}</td>
            <td>{{customer.sample_counts.WONDER}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      samples_only_list: 'admin/samples_only_list',
    }),
  },
  mounted() {
    this.get_order_list();
  },
  methods: {
    line_color: function(list_color) {
      if(list_color === 2) {
        return '#ff0000';
      }
      return '#000000';
    },
    background_color: function(background_color) {
      if(background_color === 1) {
        return '#FFFF00';
      }
      return null;
    },
    get_order_list () {
      if(this.samples_only_list.length === 0)
      {
        this.$store.dispatch('admin/getSampleOnlyList');
      }
    },
    show_customer_detail_page(customer_id) {
      this.$router.push({name: "customer_details", 'params':{customer_id: customer_id} });
    },

  }
}
</script>

<style scoped>

.full_page {
  margin-left: 20px;
  margin-right: 20px;
}

</style>
